<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<h1 class="toctitle"><a id="page_3"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter01">Crochet know-how</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">Aqua</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Azela</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">Blue</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Pansy</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Fleur</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Flora</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Hydrangea</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Leila</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">Lilac</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Lily</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter12" title="Link target outside of Sample">Moude</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter13" title="Link target outside of Sample">Orla</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter14" title="Link target outside of Sample">Petal</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter15" title="Link target outside of Sample">Rainbow</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter16" title="Link target outside of Sample">Rosie</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter17" title="Link target outside of Sample">Rouge</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Chapter18" title="Link target outside of Sample">Roux</span></h2>
<h2 class="toc"><span href="#/xhtml/25_Chapter19" title="Link target outside of Sample">Snowdrop</span></h2>
<h2 class="toc"><span href="#/xhtml/26_Chapter20" title="Link target outside of Sample">Sorrel</span></h2>
<h2 class="toc"><span href="#/xhtml/27_Chapter21" title="Link target outside of Sample">Spectrum</span></h2>
<h2 class="toc"><span href="#/xhtml/28_Chapter22" title="Link target outside of Sample">List of yarns used</span></h2>
</div>
<div class="img_container">
<img alt="image" src="images/f0003-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?7ae28e85